import styled from "styled-components";

export const IconWrapper = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 4px;

  &:hover {
    color: rgba(0,0,0,0.8);
  }
`